import { AbstractDictionary } from "./AbstractDictionary";
export class AbstractSortableDictionary extends AbstractDictionary {
  languageValue?: string | null;
}
